export default {
    url : process.env.REACT_APP_BACKEND_URL
}